import React from "react";
import DashBoardPanel from "./DashBoardPanel";
import Loading from "../../common/loading/Loading";
import { LOAD_PTO_DETAILS_SUCCESS } from "../../../redux/actions/ActionTypes";
import Information from "../../common/alerts/Information";

function PtoDetailsPanel(props) {

  return (
    <DashBoardPanel title="PTO Details">
      <Loading api={LOAD_PTO_DETAILS_SUCCESS} />
      <table className="table table-hover">
        <thead>
          <tr key="PtoDetailsTableHeaders">
            <th>Month</th>
            <th className='App-number'>Earned</th>
            <th>-</th>
            <th className='App-number'>Used</th>
            <th>=</th>
            <th className='App-number'>Net Earned</th>
            <th className='App-number'>End Of Month Balance</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{props.data.yearRolloverBalance.year} Rollover</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td className='App-number'>{props.data.yearRolloverBalance.rolloverBalance.toFixed(2)}</td>
          </tr>
          {props.data.monthDetails.map((item) => (
            <tr
              key={
                item.empPtoDetailsId.toString()
              }
            >
              <td>{item.monthName}</td>
              <td className='App-number'>{item.earnedHours.toFixed(2)}</td>
              <td></td>
              <td className='App-number'>{item.usedHours.toFixed(2)}</td>
              <td></td>
              <td className='App-number'>{item.netEarned.toFixed(2)}</td>
              <td className='App-number'>{item.endOfMonthBalance.toFixed(2)}</td>
            </tr>
            ))}
        </tbody>
        <tfoot className='App-footer'>
          <tr>
            <td>YTD Totals</td>
            <td className='App-number'>{props.data.totals.earnedHours.toFixed(2)}</td>
            <td></td>
            <td className='App-number'>{props.data.totals.usedHours.toFixed(2)}</td>
            <td></td>
            <td className='App-number'>{props.data.totals.netEarnedHours.toFixed(2)}</td>
            <td className='App-number'>{props.data.totals.availableHours.toFixed(2)}</td>
          </tr>
        </tfoot>
      </table>
      <Information title="Notes">
        <div style={{ marginBottom: "8px" }}>
          Pending PTO Requests logged in the PTO App on the Connect portal are not included.
        </div>
        <div style={{ marginBottom: "8px" }}>
          PTO is accrued monthly on the last paycheck of every month.
        </div>
        <div style={{ marginBottom: "8px" }}>
          Used hours are as of last time card.
        </div>
      </Information>
    </DashBoardPanel>
  );
}

export default PtoDetailsPanel;
